<template>
</template>

<script>
import localstorageMixin from '@/mixins/localstorageMixin.js'
export default {
  name: 'SafeStore',
  mixins : [localstorageMixin],
  data() {
    return {
      timestamps:{
        dateKey:'month',
        from: moment().startOf('month').format("YYYY-MM-DD HH:mm:ss"),
        to: moment().endOf('month').format("YYYY-MM-DD HH:mm:ss"),
        },
      data:{
        RCGB: {isLoading: false, safe:{}, transactions:undefined, store:{}, totals:{}},
        RMGB: {isLoading: false, safe:{}, transactions:undefined, store:{}, totals:{}},
        WGB : {isLoading: false, safe:{}, transactions:undefined, store:{}, totals:{}},
        SOG : {isLoading: false, safe:{}, transactions:undefined, store:{}, totals:{}},
        SOB : {isLoading: false, safe:{}, transactions:undefined, store:{}, totals:{}},
      }
    }
  },
  mounted(){
    console.log('Safe Store Loaded')
    window.atlDebug = this
    this.loadData();
  },
  methods: {
    loadData: function(){
      if (!document.hasFocus())
        return;
        
      //Strip timezone from ts 
      //Not sure if this is needed since I'm get the ts from the server
      let  from = moment(this.timestamps.from).startOf(this.timestamps.dataKey).format("YYYY-MM-DD HH:mm:ss");
      let  to = moment(this.timestamps.to).endOf(this.timestamps.dataKey).format("YYYY-MM-DD HH:mm:ss");
      //Skip if from and to are the same
      if(from === to){
        console.log('skipping')
        return
      }

      console.log('from to', from, to);

      this.$fullLocations.forEach(location=>{
        this.data[location].transactions = undefined
        this._getData('/getSafeDrops', 'safe', location)
      })
    },
    loadDataForDate: function(date, location){
      if (!document.hasFocus())
        return;
        
      //Strip timezone from ts 
      //Not sure if this is needed since I'm get the ts from the server
      let  from = moment(moment(`${date.split('T')[0]} 00:00:00`).format("YYYY-MM-DD HH:mm:ss")).startOf('day').format("YYYY-MM-DD HH:mm:ss");
      let  to = moment(moment(`${date.split('T')[0]} 23:59:59`).format("YYYY-MM-DD HH:mm:ss")).add(1, 'day').startOf('day').format("YYYY-MM-DD HH:mm:ss");
      console.log('date', date, )
      console.log('from to', from, to);
      this._getData('getSafeDropsForDate', 'transactions', location, {location, from, to})
      
    },

    _getData(endpoint, dataKey, location, options){
      this.data[location][dataKey] = {}
      this.data[location].isLoading = true;
      this.$axios.post(endpoint, options ? options : { location, from: this.timestamps.from, to: this.timestamps.to }).then((r)=>{
        this.data[location].isLoading = false;
        this.data[location][dataKey] = r.data.length > 0 ? r.data : this.data[location][dataKey]
        this.$emit('input', this.data)
      });
    }
  },
  computed:{

  },
}
</script>